import styles from "./styles.module.scss";
import WhitePlus from "@/assets/WhitePlus.svg";

const DisruptiveInclusive = ({ items = [], className = "" }) => {
  return (
    <section className={`${styles.wrapper} ${className}`}>
      {items.slice(0, 2).map((item, i) => (
        <div
          key={i}
          className={styles.card}
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(0, 96, 117, 0) 0%, rgba(0, 34, 42, 0.7) 100%), url(${item?.image?.url})`,
          }}
          data-sourceflow-prop="items"
        >
          <div className={styles.content}>
            <h3
              className={styles.title}
              data-sourceflow-prop="items.title"
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
            <a className={styles.readMore} href={item?.url || "#"} data-sourceflow-prop="items.url">
              <span className={styles.readMoreText} data-sourceflow-prop="items.ctaText">
                {item?.ctaText || "READ MORE"}
              </span>
              <WhitePlus />
            </a>
            <p
              className={styles.description}
              data-sourceflow-prop="items.description"
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          </div>
        </div>
      ))}
    </section>
  );
};

export { DisruptiveInclusive };
export default DisruptiveInclusive;
